import React, { useState } from "react";
import PanelComponent from "../../Components/PanelComponent/PanelComponent";
import * as styles from "./ApplicationApis.module.scss";
import { editApiData, saveApiData } from "../../store/slices/apiDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";
import GridTable from "cvmgmt-cube-grid-table";
import { getEnv } from "../../Constants/env";
import CreateApiPanelContent from "./CreateApiPanelContent";
import { useIdToken } from "../../hooks/useAuthSession";

interface APISProps {
  setApiEdit: (value: boolean) => void;
  appId: number;
  isEditable?: boolean;
}

const ApplicationApis: React.FC<APISProps> = ({ appId, isEditable }) => {
  const scssClass = styles as any;
  const [openPanel, setOpenPanel] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const idToken = useIdToken();
  const { env } = useSelector((state: any) => state?.createApplication);

  const tableRefresh = useSelector(
    (state: RootState) => state?.apiDetails?.tableRefresh,
  );

  const handleClose = () => setOpenPanel(false);

  return (
    <>
      {idToken && (
        <GridTable
          style={{
            ...scssClass.apiContainer,
            height: `calc(100vh - ${!isEditable ? 36.2 : 34}rem)`,
            maxWidth: "calc(100vw - 4rem)",
          }}
          customPayload={true}
          isCustomizeColumns={false}
          title="API List"
          refresh={tableRefresh}
          apiConfig={{
            url: `${getEnv()?.baseURL}/featsetup/api-details?appId=${appId}&env=${env}`,
            data: {
              sortingFilter: {
                filter: [],
                sort: [],
                page: {
                  limit: 25,
                  offset: 0,
                },
              },
            },
            headers: {
              Authorization: idToken,
              "x-api-key": "sasa",
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            documentUrl: "",
          }}
          cellActions={[
            {
              event: "Edit",
              disabled: !isEditable,
              callback: (event, row) => {
                const rowData = row?.row?.original;
                dispatch(editApiData(rowData));
                setOpenPanel(true);
                const saveApi = {
                  id: rowData?.id,
                  api_name: rowData?.api_name,
                  description: rowData?.description,
                  endpoint_path: rowData?.endpoint_path,
                  method_type: rowData?.method_type?.toUpperCase(),
                  app_id: appId,
                };
                dispatch(saveApiData(saveApi));
              },
            },
          ]}
          isPagination={true}
          showLoader={false}
        />
      )}
      {openPanel && (
        <PanelComponent
          open={openPanel}
          title="Edit API"
          isEdit={true}
          onClose={handleClose}
          BodyComponent={<CreateApiPanelContent isEdit={true} appId={appId} />}
          tabValue={2}
        />
      )}
    </>
  );
};

export default ApplicationApis;
